import { win } from "../lib/pd-window";
import { cookie } from "../lib/cookies.js";

/**
 * Wraps `track` and `identify` segment analytics calls.
 * They might mot be present due to GDPR and the callback argument might not get called.
 *
 * https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
 *
 * @arg {'track' | 'identify'} method
 * @return {(...args: any[]) => any}
 */
export function getSegment(method) {
  if (win.analytics && typeof win.analytics[method] === "function")
    return win.analytics[method];
  else return analyticsStub;
}

/** @arg {...any} args */
function analyticsStub(...args) {
  for (const arg of args) {
    if (typeof arg === "function") {
      arg();
      return;
    }
  }
}

////////////////////////////////////////////////////////////////////////////////
// Direct low level manipulation of the anonymous id
//
// Warning: Whenever possible use Segment's API to manipulate the anonymous id
// https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/identity/#anonymous-ids
//
// The reason these wrapper exist is in cases where you *need* to assume segment
// was successfully loaded (it may not due to ad blockers and user's GDPR preferences)
// in order to conditionally show content which otherwise would be blank
// The primary use case is split testing

/** @arg {string} [idValue] */
export function segmentAnonId(idValue) {
  if (idValue == null) return getSegmentAnonId();
  return setSegmentAnonId(idValue);
}

function getSegmentAnonId() {
  // ajs_anonymous_id is json encoded (both cookie and local storage)
  // thus the final null is also encoded as json to parse it uniformly
  const id =
    cookie("ajs_anonymous_id") ??
    localStorage.getItem("ajs_anonymous_id") ??
    null;
  return id;
}

// last 2 (or 1) segments o the domain preceded by "."
// e.g.: www.pagerduty.com -> .pagerduty.com
// e.g.: localhost -> .localhost
const domain = "." + location.hostname.split(".").slice(-2).join(".");

/** @arg {string} id*/
function setSegmentAnonId(id) {
  const encodedId = JSON.stringify(id);
  // Same options as segment sets
  /** @type {import("../lib/cookies").Options} */
  const cookieOpts = {
    path: "/",
    expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365), // 1 year in ms
    samesite: "lax",
    domain,
  };
  cookie("ajs_anonymous_id", encodedId, cookieOpts);
  localStorage.setItem("ajs_anonymous_id", encodedId);
}
